var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"frame",staticClass:"picture-container",attrs:{"src":'./static/plugin/picture-view/index.html?src=' + _vm.src}})
}
var staticRenderFns = []

export { render, staticRenderFns }